import React, { useState } from "react";
import "./DeletionRequestsModal.css";

const DeletionRequestsModal = ({
  show,
  handleClose,
  users,
  onBulkDelete,
  isLoading,
}) => {
  const [selectedUsers, setSelectedUsers] = useState([]);

  if (!show) return null;

  const markedForDeletion = users.filter(
    (user) => user.willBeDeleted === "Yes"
  );

  const handleSelectUser = (user) => {
    setSelectedUsers((prev) => {
      if (prev.find((u) => u.uid === user.uid)) {
        return prev.filter((u) => u.uid !== user.uid);
      }
      return [...prev, user];
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedUsers(markedForDeletion);
    } else {
      setSelectedUsers([]);
    }
  };

  return (
    <div className="deletion-requests-modal">
      <div className="deletion-requests-modal-content">
        <div className="modal-header">
          <h2 className="deletion-requests-title">Account Deletion Requests</h2>
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
        </div>

        {markedForDeletion.length === 0 ? (
          <div className="no-requests-message">
            No pending deletion requests
          </div>
        ) : (
          <>
            <div className="requests-info">
              <p>
                {markedForDeletion.length} user(s) have requested account
                deletion
              </p>
              <p className="selection-info">
                {selectedUsers.length} user(s) selected for deletion
              </p>
            </div>
            <div className="requests-table">
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={
                          selectedUsers.length === markedForDeletion.length
                        }
                      />
                    </th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Created</th>
                    <th>Last Login</th>
                  </tr>
                </thead>
                <tbody>
                  {markedForDeletion.map((user) => (
                    <tr key={user.uid}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedUsers.some(
                            (u) => u.uid === user.uid
                          )}
                          onChange={() => handleSelectUser(user)}
                        />
                      </td>
                      <td>{user.email}</td>
                      <td>{user.role}</td>
                      <td>{formatDate(user.registered)}</td>
                      <td>{formatDate(user.lastLogin)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-actions">
              <button
                className="delete-selected-button"
                onClick={() => onBulkDelete(selectedUsers)}
                disabled={isLoading || selectedUsers.length === 0}
              >
                {isLoading
                  ? "Processing..."
                  : `Delete Selected Users (${selectedUsers.length})`}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const formatDate = (dateField) => {
  if (!dateField) return "N/A";
  if (dateField && dateField._seconds) {
    return new Date(dateField._seconds * 1000).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }
  if (dateField instanceof Date) {
    return dateField.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }
  if (typeof dateField === "string") {
    return new Date(dateField).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }
  return "Invalid Date";
};

export default DeletionRequestsModal;
